import { render } from "./discordSection.vue?vue&type=template&id=9033001a&scoped=true"
import script from "./discordSection.vue?vue&type=script&lang=js"
export * from "./discordSection.vue?vue&type=script&lang=js"

import "./discordSection.vue?vue&type=style&index=0&id=9033001a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9033001a"]])

export default __exports__